import { Heading } from 'react-aria-components'
import { useNetwork } from '~/networkProvider'
import { Button } from '~/ui/Button'
import { Dialog } from '~/ui/Dialog'
import { Modal } from '~/ui/Modal'

export const ApplicationUpdatedModal = () => {
  const network = useNetwork()
  return (
    <Modal isOpen={network.showReloadNotification} isDismissable={false}>
      <Dialog>
        <Heading slot="title">Application Updated</Heading>
      </Dialog>
      <div className="px-6 pb-6 flex flex-col gap-3">
        <p className="text-center font-bold">A new version of SpecLab is available!</p>
        <p className="text-center">Reload in order to continue working.</p>
        <Button className="w-100" onClick={() => window.location.reload()}>
          Reload
        </Button>
      </div>
    </Modal>
  )
}
